import React, { useCallback } from 'react'
import { Suspense } from 'react'
import { AdvancedMarker, Pin, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps'
import InfoWindowContent from './InfoWindowContent'
import Loading from './Loading'

const MapLocationMarker = ({ location, onClick, theme, store }) => {
  const [markerRef, marker] = useAdvancedMarkerRef()
  const handleClick = useCallback(() => onClick(location), [onClick, location])

  return (
    <AdvancedMarker
      position={{ lat: location.latNumber, lng: location.lngNumber }}
      ref={markerRef}
      onClick={handleClick}
      className="marker feature"
    >
      <Pin
        borderColor={theme.palette.primary.main}
        background={theme.palette.primary.light}
        glyphColor={theme.palette.primary.main}
      />
      {store.locationStore.focusedLocation && store.locationStore.focusedLocation.id === location.id ? (
        <InfoWindow
          anchor={marker}
          disableAutoPan
          maxWidth={408}
          onCloseClick={() => store.locationStore.resetFocusLocation()}
        >
          <Suspense
            fallback={
              <Loading message={'Loading InfoWindow Content...'} />
            }
          >
            <InfoWindowContent location={location} />
          </Suspense>
        </InfoWindow>
      ) : null}
    </AdvancedMarker>
  )
}

export default MapLocationMarker 